module.exports = __webpack_public_path__ + "static/media/cluster-resources.95e3ab88.jpg";